module.exports = __webpack_public_path__ + "assets/fonts/e01581eb6644df3b6eea2a854c10cc22.woff";